import { analytics } from "@/analytics/analytics";

const API_BASE_URL: string = import.meta.env.VITE_API_URL || "";

function withBase(path: string): string {
  return `${API_BASE_URL.replace(/\/$/, "")}${path}`;
}

async function postJson(url: string, body: Record<string, unknown>) {
  const resp = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(body),
  });
  const text = await resp.text();
  let data: any;
  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    data = { raw: text };
  }
  if (!resp.ok) {
    const msg = data?.error || data?.message || text || `Request failed (${resp.status})`;
    throw new Error(msg);
  }
  return data;
}

export async function logoutAll() {
  analytics.reset();
  // Clear ALL recruit_ai_* sessionStorage keys
  try {
    Object.keys(sessionStorage)
      .filter(k => k.startsWith("recruit_ai_"))
      .forEach(k => sessionStorage.removeItem(k));
  } catch {}
  // Clear ALL recruit_ai_* localStorage keys
  try {
    Object.keys(localStorage)
      .filter(k => k.startsWith("recruit_ai_"))
      .forEach(k => localStorage.removeItem(k));
  } catch {}
  return postJson(withBase("/auth/logout"), {});
}
